import { InjectionToken } from '@angular/core';

interface IdentityConfig {
  releaseNotes: string;
  logoPath: string;
  initialAuthorizedUrl: string;
  unauthorizedUrl: string;
  unauthorizeUrl: string;
  urlsNotToNavigateToUnauthorizeUrl: string[];
}

export const IDENTITY_CONFIG = new InjectionToken<IdentityConfig>(
  'IDENTITY_CONFIG',
);
